import React, { useEffect } from 'react';

interface AdContainerProps {
  adId: string;
  className?: string;
}

export const AdContainer: React.FC<AdContainerProps> = ({ adId, className }) => {
  const isAdsDisabled = process.env.REACT_APP_DISABLE_ADS === 'true';

  useEffect(() => {
    if (!isAdsDisabled && !document.querySelector('script[src*="lngtd.com/mathler.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://lngtd.com/mathler.js';
      script.async = true;
      document.head.appendChild(script);
    }
  }, [isAdsDisabled]);

  if (isAdsDisabled) {
    return null;
  }

  return <div id={adId} className={className}></div>;
};